import { render, staticRenderFns } from "./TermsAndConditionsPage.vue?vue&type=template&id=30d99d92&scoped=true&"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=30d99d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d99d92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRadio,VRadioGroup,VRow})
